import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var text_color_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M12.9 6h-2l-4 11h1.9l1.1-3h4.2l1.1 3h1.9L12.9 6zm-2.5 6.5l1.5-4.9 1.7 4.9h-3.2z" }) });
export {
  text_color_default as default
};
//# sourceMappingURL=text-color.js.map
